<template>
  <el-dialog
    :title="'发送短信'"
    :visible="true"
    :before-close="closeForm"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="1200px"
  >
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="用户列表" prop="username">
        <el-transfer
          v-model="ruleForm.valueList"
          :data="_SMSList"
          :titles="['未选', '已选']"
        ></el-transfer>
      </el-form-item>
      <el-form-item label="短信内容" prop="smsContent">
        <el-input
          v-model.trim="ruleForm.smsContent"
          type="textarea"
          :rows="3"
        ></el-input>
      </el-form-item>
      <div class="align-center">
        <el-button
          type="primary"
          @click="sendSMS()"
          :disabled="
            ruleForm.smsContent.length === 0 || ruleForm.valueList.length === 0
          "
          >发送短信</el-button
        >
        <el-button @click="closeForm()">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  props: {
    SMSList: {
      type: Array,
      default: () => {
        return new Array();
      }
    }
  },
  data() {
    return {
      ruleForm: {
        valueList: [],
        smsContent: ""
      }
    };
  },
  computed: {
    _SMSList() {
      this.SMSList.forEach(ele => {
        ele.label = ele.username + "：" + ele.usermobile;
        ele.key = ele.weixinOpenid;
        ele.disabled = false;
      });
      return this.SMSList;
    }
  },
  methods: {
    sendSMS() {
      let requestModel = {
        userNames: [this.ruleForm.username],
        disabled: this.ruleForm.disabled
      };

      this.$axios(this.$urlMapping["批量发送短信"], {
        data: requestModel
        // eslint-disable-next-line no-unused-vars
      }).then(result => {
        this.$notifySuccess();
        this.$emit("onSearch");
        this.$emit("closeForm");
      });
      return false;
    },
    closeForm() {
      this.$emit("closeForm");
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.ruleForm.valueList = this._SMSList.map(ele => {
        return ele.key;
      });
    });
  }
};
</script>

<style lang="less" scoped>
.demo-ruleForm {
  /deep/ .el-transfer-panel {
    width: 45%;
  }
  /deep/ .el-transfer-panel__item.el-checkbox {
    display: block;
  }

  /deep/ .el-transfer-panel__body {
    height: 320px;
  }
  /deep/ .el-transfer-panel__list {
    height: 320px;
  }
}
</style>
